import React, { FC } from 'react'
import { TabPanel, TabPanels as HeadlessTabPanels } from '@headlessui/react'
import { TabContent } from '../TabContent'
import { TabPanelsProps } from './types'

const MultiTabPanels: FC<{ tabs: TabPanelsProps['tabs'] }> = ({ tabs }) => (
  <>
    {tabs.map((tab) => (
      <TabPanel key={tab.title} className="w-full">
        <TabContent tab={tab} />
      </TabPanel>
    ))}
  </>
)

export const TabPanels: FC<TabPanelsProps> = ({ tabs }) => (
  <HeadlessTabPanels className="w-full">
    <MultiTabPanels tabs={tabs} />
  </HeadlessTabPanels>
)
